import type { ReviewedLibraryIdentity } from './library-identity-types';

export const LIBRARY_STRETCH_02: ReviewedLibraryIdentity[] = [
  {
    "id": "library-personal-s1-sternocleidomastoid",
    "name": "胸锁乳突肌静态拉伸",
    "group": "stretch",
    "subCategory": "neck",
    "equipment": "bodyweight",
    "pattern": "静态拉伸",
    "legacyIds": [
      "personal-s1-sternocleidomastoid"
    ],
    "sourceId": "course-20261008-personal-01-13",
    "targetMuscles": [
      "胸锁乳突肌"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-personal-s1-scalene-release",
    "name": "斜角肌松解",
    "group": "stretch",
    "subCategory": "neck",
    "equipment": "bodyweight",
    "pattern": "颈部放松松解",
    "legacyIds": [
      "personal-s1-scalene-release"
    ],
    "sourceId": "course-20261008-personal-01-14",
    "targetMuscles": [
      "斜角肌"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-personal-s1-platysma-stretch",
    "name": "颈阔肌静态拉伸",
    "group": "stretch",
    "subCategory": "neck",
    "equipment": "bodyweight",
    "pattern": "静态拉伸",
    "legacyIds": [
      "personal-s1-platysma-stretch"
    ],
    "sourceId": "course-20261008-personal-01-15",
    "targetMuscles": [
      "颈阔肌"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  }
];
